import { create } from "zustand";
import { HexGroupI } from "@/types/base";

interface SelectedHexGroupState {
  selectedHexGroup: HexGroupI | null;
  currentHexGroup: HexGroupI | null;
  setSelectedHexGroup: (elem: HexGroupI | null) => void;
  setCurrentHexGroup: (elem: HexGroupI | null) => void;
}

export const useSelectedHexGroupStore = create<SelectedHexGroupState>()(
  (set) => ({
    selectedHexGroup: null,
    currentHexGroup: null,
    setSelectedHexGroup: (elem) =>
      set(() => ({
        selectedHexGroup: elem,
      })),
    setCurrentHexGroup: (elem) =>
      set(() => ({
        currentHexGroup: elem,
      })),
  })
);
